import React from 'react';

import '../../../Statics/Scss/Components/Hamburguer.scss';



const Hamburguer = ({ onClick, size }) => {

    const className = `com-hamburguer${ size ? ` ${size}` : ``}`

    return (
        <button 
            className = { className }
            onClick   = { onClick }
            aria-label="Abrir Menú"
        >
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
        </button>
    );
}



export default Hamburguer;